import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function IncludesChecklist() {
  const items = ['Archivos en alta resolución listos para imprimir', 'Formato PDF y PNG compatible con cualquier imprenta', 'Fondo transparente para recorte perfecto', 'Optimizado para impresora hogareña o imprenta local', 'Descarga inmediata — lo tenés en minutos', 'Acceso de por vida — descargás cuando querés'];
  return <section className="py-12 bg-black border-y border-sky-900/40" data-id="element-132">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-133">
        <h3 className="text-2xl font-bold text-center mb-10 text-white" data-id="element-134">
          ✅ Todo el pack incluye:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4" data-id="element-135">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="flex items-start gap-3 p-3 rounded-lg hover:bg-zinc-900/50 transition-colors" data-id="element-136">
              <CheckCircle2 className="w-5 h-5 text-sky-400 shrink-0 mt-0.5" data-id="element-137" />
              <span className="text-zinc-100 font-medium text-[16px]" data-id="element-138">
                {item}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}